// extracted by mini-css-extract-plugin
module.exports = {"auctionPageTitle":"List_auctionPageTitle_14dXL","createOrderButton":"List_createOrderButton_tsEGs"};